<template>
  <v-footer
    class="secondary"
    dark
    padless
    :style="
      $store.state.app.display === 'xs' || $store.state.app.display === 'sm'
        ? 'padding-bottom:68px'
        : ''
    "
  >
    <v-col class="text-center" cols="12">
      <v-card flat tile class="secondary white--text text-center">
        <v-card-text>
          <v-btn
            v-for="(link, i) in $store.state.app.footer.social_links"
            :key="i"
            class="mx-4 white--text"
            icon
            :href="link"
            target="_blank"
          >
            <v-icon size="24px">{{ $helpers.linkIcon(link) }}</v-icon>
          </v-btn>
        </v-card-text>

        <v-card-text class="white--text pt-0">
          {{ $store.state.app.footer.description }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="white--text">
          <strong>WhyBuy</strong>
          <span class="mx-2">-</span>
          &copy; {{ new Date().getFullYear() }}
        </v-card-text>
        <v-card-text>
          <router-link class="nolink" to="/terms">User Terms</router-link>
          <span class="mx-2">-</span>
          <router-link class="nolink" to="/business-terms"
            >Business Terms</router-link
          >
          <span class="mx-2">-</span>
          <router-link class="nolink" to="/privacy">Privacy</router-link>
          <span class="mx-2">-</span>
          <router-link class="nolink" to="/affiliate-disclaimer"
            >Affiliate Disclaimer</router-link
          >
          <span class="mx-2">-</span>
          <router-link class="nolink" to="/cookies-policy"
            >Cookies Policy</router-link
          >
        </v-card-text>
      </v-card>
    </v-col>
  </v-footer>
</template>
<script>
export default {
  name: "",
  data: () => ({}),
};
</script>
<style lang="scss" scoped>
</style>
